module.exports = __webpack_public_path__ + "img/glossary-icon.99d760bd.svg";